import { apiClient } from "./ApiClient";

export async function fetchUsersAdmin({ skip, limit, sort_by, sort_order, filters }) {
  const params = new URLSearchParams({ skip, limit, sort_by, sort_order });

  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      params.append(key, filters[key]);
    }
  }

  const response = await apiClient.get(`/user/admin/batch?${params}`);
  return response.data;
}

export async function updateUser({ userData }) {
  const response = await apiClient.put("/user/update", userData);
  return response.data;
}

export async function deleteUser({ email }) {
  const response = await apiClient.delete(`/user/${encodeURIComponent(email)}`);
  return response.data;
}

export const markNewsletter = async (email, subscribe) => {
  const { data } = await apiClient.patch(`/user/${encodeURIComponent(email)}/newsletter`, { subscribe });
  return data;
};
